// Stefans-AI-CV-frontend/src/sections/StatsSection.tsx

import { motion } from 'framer-motion'
import { useI18n } from '../i18n'

const stats = [
  { value: '15+', key: 'experience' },
  { value: '$2M+', key: 'tvl' },
  { value: '60%+', key: 'yield' },
  { value: '30+', key: 'articles' },
]

// Color config per stat
const statColors: Record<string, string> = {
  experience: 'cyan',
  tvl: 'indigo',
  yield: 'cyan',
  articles: 'indigo',
}

export default function StatsSection() {
  const t = useI18n()

  const getLabel = (key: string) => {
    const labels: Record<string, string> = {
      experience: t.stats.experience,
      tvl: t.stats.tvl,
      yield: t.stats.yield,
      articles: t.stats.articles,
    }
    const sublabels: Record<string, string> = {
      experience: t.stats.experience_label,
      tvl: t.stats.tvl_label,
      yield: t.stats.yield_label,
      articles: t.stats.articles_label,
    }
    return { label: labels[key], sub: sublabels[key] }
  }

  return (
    <section className="py-16 border-t border-b border-border relative overflow-hidden">
      {/* subtle bg */}
      <div className="absolute inset-0 bg-bg-elevated/30" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, i) => {
            const { label, sub } = getLabel(stat.key)
            return (
              <motion.div
                key={stat.key}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className={`group glass-card rounded-2xl p-6 text-center hover:border-border-strong transition-all duration-300 ${statColors[stat.key] === 'indigo' ? 'hover:glow-indigo' : 'hover:glow-cyan'}`}
              >
                <div className={`font-mono font-bold text-3xl md:text-4xl mb-1 group-hover:scale-105 transition-transform duration-300 ${statColors[stat.key] === 'indigo' ? 'text-indigo-400' : 'text-gradient-cyan'}`}>
                  {stat.value}
                </div>
                <div className="text-text-secondary text-sm font-semibold mb-1">{label}</div>
                <div className="text-text-muted text-xs leading-relaxed">{sub}</div>
              </motion.div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
